<section class="filter-header">
  <h2>Filtros</h2>
</section>
<section class="filter-container">
  <app-video-query-elements [accentColorInHex]="'#ff8c00'" class="filter-element"
    [(filters)]="filters"></app-video-query-elements>
</section>
<section class="actions">
  <button type="button" (click)="applyFilters()">
    <mat-icon> check </mat-icon>
    <div>Aplicar</div>
  </button>
  <button type="button" (click)="resetFilters()">
    <mat-icon> delete </mat-icon>
  </button>
</section>